export const delayFormatting = (delay?: string) => delay?.substring(0, delay?.length - 3);
